import curry from "./curry.js";

export default curry(function divide(a, b) {
  return a / b;
});
